/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React from 'react';

// REDUX
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

// COMPONENTS
import Filter from '../Filter/Filter';

import styles from './Header.module.scss';

const menuIcon = require('./imgs/menu-icon.svg');
const appIcon = require('./imgs/app-icon.png');
const appLogo = require('./imgs/logo.png');

const Header = ({ toggleNav, stickyFilter }) => (
  <div className={styles.componentWrapper}>
    <div className={styles.componentContainer}>
      <img alt="icon" src={appIcon} />
      <img alt="logo" src={appLogo} />
      <img alt="nav-menu" onClick={() => toggleNav()} src={menuIcon} />
    </div>
    <div className={[
      styles.filterWrapper,
      stickyFilter ? styles.sticky : null,
    ].join(' ')}
    >
      <Filter />
    </div>
  </div>
);

Header.propTypes = {
  toggleNav: PropTypes.func.isRequired,
  stickyFilter: PropTypes.bool,
};

Header.defaultProps = {
  stickyFilter: false,
};

const mapStateToProps = (state) => {
  const { stickyFilter } = state.elements;
  return { stickyFilter };
};

export default connect(mapStateToProps)(Header);
